import React from 'react';

import { sendAnswers, usePayment } from '../../store/PaymentContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCommon } from '../../store/CommonContext';
import { useTemplate } from '../../store/TemplateContext';
import { sendLinksAnswers, useLinks } from '../../store/LinksContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';

import './CloseButton.css';

interface IProps {
  dataid: string | null;
}

const CloseButton: React.FC<IProps> = props => {
  const { dataid } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');

  const {
    state: { configuration },
    dispatch: commonDispatch,
  } = useCommon();
  const { dispatch: templateDispatch } = useTemplate();
  const { dispatch: paymentDispatch } = usePayment();
  const { dispatch: linksDispatch } = useLinks();

  const handleClose = (): void => {
    if (location.pathname.includes('links')) {
      sendLinksAnswers({
        answers: { answers: { [dataid || '']: true }, id },
        dispatch: linksDispatch,
        navigate,
      });
    } else {
      sendAnswers({
        answers: { [dataid || '']: true },
        dispatch: paymentDispatch,
        navigate,
        location,
        configuration,
        commonDispatch,
        templateDispatch,
      });
    }
  };

  return <FontAwesomeIcon icon={faXmark} className="ui-widget-close-modal-icon" onClick={handleClose} />;
};

export default CloseButton;
